import { c as _c } from "react/compiler-runtime";
import type { CSSProperties, JSX } from "react";
import type { ThankYouEmbedBlock } from '../types';
import styles from './ThankYouEmbed.module.css';
interface ThankYouEmbedProps {
  block: ThankYouEmbedBlock;
  blockId: string;
}
interface ThankYouEmbedStyle extends CSSProperties {
  '--category-thank-you-embed-height'?: string;
}

/**
 * Magento source uses `<object data="...thankyou.getscw.com...">` for the
 * thank-you embed pages. Per CLAUDE.md + the parity-gate transform
 * `thankYouObjectToIframe`, we always render as `<iframe>` regardless of source
 * tag, preserving the URL string verbatim.
 */
export function ThankYouEmbed(t0) {
  const $ = _c(12);
  const {
    block,
    blockId
  } = t0;
  const t1 = block.height ?? "600px";
  const t2 = block.width ?? "100%";
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = {
      "--category-thank-you-embed-height": t1,
      border: 0,
      width: t2
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const inlineStyle = t3;
  const t4 = block.hidden || undefined;
  const t5 = block.title ?? "Embedded thank-you content";
  let t6;
  if ($[3] !== block.url || $[4] !== inlineStyle || $[5] !== t5) {
    t6 = <iframe src={block.url} title={t5} loading="lazy" style={inlineStyle} className={styles.iframe} />;
    $[3] = block.url;
    $[4] = inlineStyle;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== block.sourceKind || $[8] !== blockId || $[9] !== t4 || $[10] !== t6) {
    t7 = <div className={styles.wrapper} data-cms-block-id={blockId} data-cms-field="thankYouEmbed" data-source-kind={block.sourceKind} hidden={t4}>{t6}</div>;
    $[7] = block.sourceKind;
    $[8] = blockId;
    $[9] = t4;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
}